import type { Game } from '../hooks/useGames';
import type { GameLive } from '../hooks/useGamesLive';
import GameCard from './GameCard';
import GameCardLive from './GameCardLive';
import { TabId } from './TabBar';

interface GameGridProps {
  games: Game[];
  menu: { style?: string };
  selectedTab: TabId;
  gamesLive: GameLive[];
  onGamePlay: (game: Game) => void;
  onGameInfo: (game: Game) => void;
  onGamePromoClick?: (promoUrl: string) => void;
}

export default function GameGrid({
  games,
  menu,
  selectedTab,
  gamesLive,
  onGamePlay,
  onGameInfo,
  onGamePromoClick
}: GameGridProps) {
  const isLiveTab = selectedTab === TabId.CASINO_LIVE;
  const findLiveGameById = (gameId: string) => gamesLive.find(game => game.id === gameId);

  return (
    <div className="px-6 pt-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 justify-items-center">
        {games.map((game, index) => {
          if (isLiveTab && game.type === 'casinolive') {
            const liveGame = findLiveGameById(game.id);
            if (liveGame) {
              return (
                <GameCardLive
                  key={game.id}
                  gameLive={liveGame}
                  game={game}
                  onPlay={onGamePlay}
                />
              );
            }
          }
          
          return (
            <GameCard
              key={game.id}
              game={game}
              size="medium"
              onPlay={onGamePlay}
              onInfo={onGameInfo}
              onPromoClick={onGamePromoClick}
              rank={menu.style === 'RANK' ? index + 1 : undefined}
            />
          );
        })}
      </div>
    </div>
  );
}